import React from 'react';
import { InputProps } from 'antd';
import { SearchOutlined } from '@ant-design/icons';
import * as S from './styles';

export function SearchInput({ value, onChange, ...props }: Readonly<InputProps>) {
	return (
		<S.CustomInput
			{...props}
			allowClear
			value={value}
			onChange={onChange}
			prefix={<SearchOutlined style={{ fontSize: 14 }} />}
		/>
	);
}
